import { render, staticRenderFns } from "./AppraisalRecordGrid.vue?vue&type=template&id=b411232c"
import script from "./AppraisalRecordGrid.vue?vue&type=script&lang=js"
export * from "./AppraisalRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports